import { render, staticRenderFns } from "./preMatch.vue?vue&type=template&id=b4a8af32&scoped=true"
import script from "./preMatch.vue?vue&type=script&lang=js"
export * from "./preMatch.vue?vue&type=script&lang=js"
import style0 from "./preMatch.vue?vue&type=style&index=0&id=b4a8af32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8af32",
  null
  
)

export default component.exports